import React, { useState, useRef, useEffect } from 'react';
import TitleToOption from '../common/TitleToOption';
import MediaSwiperList from './MediaSwiperList';

import { useHistory } from 'react-router-dom';

const ContentsList = ({
  list,
  wrap,
  title,
  showCnt,
  padding,
  type,
  detail,
  playBtn,
  optionType,
  contetentHeight,
  titleStyle,
  animation,
  imgOpacity,
  hide,
}) => {
  const history = useHistory();

  const [contentsHide, setContentsHide] = useState(false);
  const [pagination, setPagination] = useState([]);
  const [paginationSelect, setPaginationSelect] = useState(0);

  const preArrow = useRef();
  const nextArrow = useRef();

  useEffect(() => {
    setContentsHide(hide ? true : false);
  }, [hide]);

  const filckingChange = e => {
    setPaginationSelect(e?.index);
  };

  const goDetail = data => {
    let url;
    let param = data.id;

    if (detail === 'sub-vod') {
      url = 'vod-detail';
      param = `${data.id}`;
    }
    if (detail === 'today-program') {
      url = 'vod-detail';
      param = `${data?.program?.id}`;
    }
    if (detail === 'vod-record') {
      url = 'program-detail';
      param = `${data.programId}&ep=${data.episodeId}`;
    }
    if (detail === 'vod-detail') {
      url = 'program-detail';
      param = `${data.programId}&ep=${data.id}`;
    }
    if (detail === 'youtube') {
      url = 'youtube-detail';
      param = data.id;
    }
    if (detail === 'shopping') {
      if (data.link) window.open(data.link);
      return false;
    }

    history.push(process.env.PUBLIC_URL + `/${url}?id=${param}&tab=-1`);
  };

  return (
    <>
      {!contentsHide && (
        <article style={{ padding: padding, position: 'relative' }}>
          <TitleToOption
            title={title}
            titleStyle={titleStyle}
            optionType={optionType}
            preArrow={preArrow}
            nextArrow={nextArrow}
            pagination={pagination}
            paginationSelect={paginationSelect}
          />
          <MediaSwiperList
            list={list}
            showCnt={showCnt}
            type={type}
            playBtn={playBtn}
            wrap={wrap}
            goDetail={goDetail}
            preArrow={preArrow}
            nextArrow={nextArrow}
            optionType={optionType}
            contetentHeight={contetentHeight}
            filckingChange={filckingChange}
            paginationCnt={setPagination}
            animation={animation}
            imgOpacity={imgOpacity}
          />
        </article>
      )}
    </>
  );
};

export default ContentsList;
